export enum FloorPlanDecorationType {
  WALL = "WALL",
  DOOR = "DOOR",
  WINDOW = "WINDOW",
  COLUMN = "COLUMN",
  OTHER = "OTHER",
}
